const sampleData = `年月日時,気温(℃),降水量(mm),風速(m/s),風向
2019/4/1 1:00:00,9.5,0,7.5,西
2019/4/1 2:00:00,9.1,0,6.1,西
2019/4/1 3:00:00,9.1,0,6.5,北西
2019/4/1 4:00:00,8.9,0,5.4,西北西
2019/4/1 5:00:00,7.7,0,7.4,北西
2019/4/1 6:00:00,7.8,0,7.4,北西
2019/4/1 7:00:00,7.5,0,6.3,北西
2019/4/1 8:00:00,8.3,0,8.4,北西
2019/4/1 9:00:00,8.1,0,7.8,北西
2019/4/1 10:00:00,8.1,0,7.3,北西
2019/4/1 11:00:00,9.6,0,8.6,北西
2019/4/1 12:00:00,10.2,0,8.6,北西
2019/4/1 13:00:00,10.5,0,8.1,西北西
2019/4/1 14:00:00,10.6,0,7,西北西
2019/4/1 15:00:00,11.4,0,6.9,北西
2019/4/1 16:00:00,10.3,0,6.5,西北西
2019/4/1 17:00:00,10.4,0,6.5,北西
2019/4/1 18:00:00,9.9,0,5.5,西北西
2019/4/1 19:00:00,9.7,0,4.1,西南西
2019/4/1 20:00:00,9.3,0,3.5,南西
2019/4/1 21:00:00,8.7,0,4.6,南南東
2019/4/1 22:00:00,8.5,1,7.3,西北西
2019/4/1 23:00:00,9.7,0,7,西北西
2019/4/2 00:00:00,7.9,0,1.1,東南東
2019/4/2 1:00:00,8.2,0,2.8,北東
2019/4/2 2:00:00,6.9,0,3.3,南東
2019/4/2 3:00:00,6.3,0,2.5,東南東
2019/4/2 4:00:00,5.9,0,3.9,南南東
2019/4/2 5:00:00,5.3,0,4.3,南南東
2019/4/2 6:00:00,5.3,0,3.2,南東
2019/4/2 7:00:00,5.6,0,4,南南東
2019/4/2 8:00:00,8,0,2.8,南南東
2019/4/2 9:00:00,12.2,0,5.9,西北西
2019/4/2 10:00:00,11.4,0,5.3,北西
2019/4/2 11:00:00,13,0,6,北北西
2019/4/2 12:00:00,13.5,0,5.8,北西
2019/4/2 13:00:00,13,0,5.2,北西
2019/4/2 14:00:00,13.7,0,5.5,北北西
2019/4/2 15:00:00,12.7,0,6.1,北北西
2019/4/2 16:00:00,12.5,0,5.4,北西
2019/4/2 17:00:00,12.5,0,6,北西
2019/4/2 18:00:00,12,0,4.8,西北西
2019/4/2 19:00:00,11,0,4.4,西北西
2019/4/2 20:00:00,10.9,0,3.5,西北西
2019/4/2 21:00:00,10.8,0,3.4,西
2019/4/2 22:00:00,10,0,2.4,南西
2019/4/2 23:00:00,8.3,0,2.2,南南東
2019/4/3 00:00:00,7.2,0,3,南南東
2019/4/3 1:00:00,7.3,0,1.5,南東
2019/4/3 2:00:00,7.6,0,3,南南東
2019/4/3 3:00:00,7.2,0,3.5,南南東
2019/4/3 4:00:00,7.4,0,3.4,南南東
2019/4/3 5:00:00,7.4,0,1.7,南
2019/4/3 6:00:00,7.3,0,1.2,東南東
2019/4/3 7:00:00,8.2,0,1.4,南
2019/4/3 8:00:00,9.3,0,1,北東
2019/4/3 9:00:00,10.5,0,2.6,北東
2019/4/3 10:00:00,11.9,0,2.5,西北西
2019/4/3 11:00:00,12.7,0,4,北西
2019/4/3 12:00:00,12.7,0,4,西北西
2019/4/3 13:00:00,13.7,0,5.4,北西
2019/4/3 14:00:00,13.8,0,5.2,北西
2019/4/3 15:00:00,13.5,0,6.1,北西
2019/4/3 16:00:00,12.8,0,5.5,北西
2019/4/3 17:00:00,12.2,0,4.7,北西
2019/4/3 18:00:00,11.6,0,4.3,北北西
2019/4/3 19:00:00,11.1,0,4.3,北西
2019/4/3 20:00:00,11,0,3.9,西
2019/4/3 21:00:00,10.2,0,3.3,西南西
2019/4/3 22:00:00,9.7,0,3.3,南西
2019/4/3 23:00:00,7.8,0,1.4,南南西
2019/4/4 00:00:00,6.9,0,3.1,東南東
2019/4/4 1:00:00,6.6,0,3.5,南
2019/4/4 2:00:00,6.1,0,2.7,南東
2019/4/4 3:00:00,6.6,0,1.8,南東
2019/4/4 4:00:00,5.6,0,3.8,南南東
2019/4/4 5:00:00,5.8,0,3.5,南南東
2019/4/4 6:00:00,5.3,0,3.7,南南東
2019/4/4 7:00:00,6.4,0,3.8,南南東
2019/4/4 8:00:00,9.4,0,5,南南東
2019/4/4 9:00:00,11.2,0,3.5,南
2019/4/4 10:00:00,12.8,0,2.1,南南西
2019/4/4 11:00:00,15.4,0,4.2,西北西
2019/4/4 12:00:00,15.1,0,5.2,北西
2019/4/4 13:00:00,16.8,0,6.4,北西
2019/4/4 14:00:00,16.7,0,6.1,北西
2019/4/4 15:00:00,16.5,0,6.2,北西
2019/4/4 16:00:00,16.5,0,6.2,北西
2019/4/4 17:00:00,16.3,0,5.5,北西
2019/4/4 18:00:00,15.6,0,4.2,西北西
2019/4/4 19:00:00,15.6,0,3.2,西
2019/4/4 20:00:00,14.7,0,2.5,西
2019/4/4 21:00:00,12.5,0,2.1,東南東
2019/4/4 22:00:00,12.1,0,1.1,東北東
2019/4/4 23:00:00,11.4,0,1.2,東
2019/4/5 00:00:00,10.3,0,1.4,東南東
2019/4/5 1:00:00,10.5,0,1.1,東南東
2019/4/5 2:00:00,11.5,0,3.3,南
2019/4/5 3:00:00,11.6,0,4.5,南南東
2019/4/5 4:00:00,11.6,0,4.5,南南東
2019/4/5 5:00:00,11.3,0,3.9,南東
2019/4/5 6:00:00,10.7,0,4.2,南南東
2019/4/5 7:00:00,11.8,0,4.3,南南東
2019/4/5 8:00:00,13.9,0,3.4,南南東
2019/4/5 9:00:00,14.8,0,2.5,東南東
2019/4/5 10:00:00,15.6,0,2.9,南東
2019/4/5 11:00:00,17.5,0,2.4,南南西
2019/4/5 12:00:00,17.3,0,3.8,北西
2019/4/5 13:00:00,17.3,0,3.6,北北西
2019/4/5 14:00:00,18.1,0,3.8,南
2019/4/5 15:00:00,18.8,0,2.5,南
2019/4/5 16:00:00,19.4,0,5.5,西北西
2019/4/5 17:00:00,18.5,0,6.6,北西
2019/4/5 18:00:00,17,0,4.1,西北西
2019/4/5 19:00:00,16.5,0,2.7,西
2019/4/5 20:00:00,15.5,0,4.1,南
2019/4/5 21:00:00,13.7,0,3.1,南南東
2019/4/5 22:00:00,12.7,0,1.6,東南東
2019/4/5 23:00:00,11.7,0,1.6,東南東
2019/4/6 00:00:00,11.2,0,1.8,南南東
2019/4/6 1:00:00,10.9,0,2.3,南東
2019/4/6 2:00:00,10.6,0,1.4,東南東
2019/4/6 3:00:00,10.6,0,3.7,南南東
2019/4/6 4:00:00,9.8,0,0.6,東
2019/4/6 5:00:00,8.8,0,0.4,南東
2019/4/6 6:00:00,9.9,0,0.8,南南東
2019/4/6 7:00:00,10.6,0,1.1,東南東
2019/4/6 8:00:00,14.2,0,3.1,南南東
2019/4/6 9:00:00,16.3,0,5.3,南南東
2019/4/6 10:00:00,18,0,2.7,南南東
2019/4/6 11:00:00,18.8,0,1.3,北北西
2019/4/6 12:00:00,20.2,0,2,北東
2019/4/6 13:00:00,20.8,0,4.4,北西
2019/4/6 14:00:00,21.1,0,4.5,西北西
2019/4/6 15:00:00,20.4,0,6.2,北西
2019/4/6 16:00:00,19.9,0,4.5,北西
2019/4/6 17:00:00,18.6,0,5.2,北西
2019/4/6 18:00:00,17.1,0,4.2,北西
2019/4/6 19:00:00,16.6,0,2.1,北
2019/4/6 20:00:00,15.9,0,2.7,北西
2019/4/6 21:00:00,14.9,0,2,北東
2019/4/6 22:00:00,14,0,1.8,東北東
2019/4/6 23:00:00,13.6,0,2.2,南東
2019/4/7 00:00:00,12.6,0,1.3,北北西
2019/4/7 1:00:00,13.4,0,3.2,南南東
2019/4/7 2:00:00,12.8,0,3.5,南
2019/4/7 3:00:00,11.1,0,1.1,南
2019/4/7 4:00:00,10.5,0,1.5,南東
2019/4/7 5:00:00,11.8,0,1.3,東
2019/4/7 6:00:00,12.6,0,5.2,南南東
2019/4/7 7:00:00,13.2,0,4.9,南東
2019/4/7 8:00:00,14.7,0,5,南南東
2019/4/7 9:00:00,16.1,0,6.7,南南東
2019/4/7 10:00:00,17.8,0,7.3,南南東
2019/4/7 11:00:00,20.2,0,5.1,南南東
2019/4/7 12:00:00,21.4,0,0.8,北東
2019/4/7 13:00:00,22.1,0,5.2,北北西
2019/4/7 14:00:00,20.3,0,5.5,北北西
2019/4/7 15:00:00,20.4,0,6.2,北西
2019/4/7 16:00:00,18.9,0,5.5,北北西
2019/4/7 17:00:00,17.9,0,5.6,北北西
2019/4/7 18:00:00,16.8,0,5,北西
2019/4/7 19:00:00,16.7,0,4.3,北西
2019/4/7 20:00:00,16.8,0,3.2,西北西
2019/4/7 21:00:00,16.2,0,1.5,南東
2019/4/7 22:00:00,16.2,0,2.3,南南東
2019/4/7 23:00:00,15.3,0,0.7,南東
2019/4/8 00:00:00,15.3,3,5.2,北北西
2019/4/8 1:00:00,13.9,6.5,7.3,北
2019/4/8 2:00:00,13.8,0,3.7,北北西
2019/4/8 3:00:00,13.5,0,2,北
2019/4/8 4:00:00,14.2,0,2.1,北西
2019/4/8 5:00:00,13.5,0,1.7,北西
2019/4/8 6:00:00,14.2,0,2.6,西北西
2019/4/8 7:00:00,14.3,0,1.8,西
2019/4/8 8:00:00,14.9,0,0.9,北北西
2019/4/8 9:00:00,16.3,0,1.2,南西
2019/4/8 10:00:00,16.8,0,3.6,北西
2019/4/8 11:00:00,18.1,0,5,北西
2019/4/8 12:00:00,17.5,0,5.6,北西
2019/4/8 13:00:00,18.2,0,5.8,北西
2019/4/8 14:00:00,18.7,0,5.8,北西
2019/4/8 15:00:00,18.9,0,5,北北西
2019/4/8 16:00:00,18.6,0,5.8,北西
2019/4/8 17:00:00,17.8,0,5.3,北西
2019/4/8 18:00:00,16.7,0,6.3,北西
2019/4/8 19:00:00,16.1,0,3,西北西
2019/4/8 20:00:00,15.4,0,1.2,西北西
2019/4/8 21:00:00,15.6,0,2.5,西北西
2019/4/8 22:00:00,13.8,0,4.7,北
2019/4/8 23:00:00,13.2,0,2.9,北
2019/4/9 00:00:00,12.9,0,2,北
2019/4/9 1:00:00,11.2,0,2.4,東北東
2019/4/9 2:00:00,11.8,0,2.6,東
2019/4/9 3:00:00,11.4,0,2.1,東北東
2019/4/9 4:00:00,11.2,0,1.2,東南東
2019/4/9 5:00:00,10.6,0,0.6,北東
2019/4/9 6:00:00,9,0,0.9,西南西
2019/4/9 7:00:00,10.5,0,0.9,北西
`;


export function getSampleData() {
    return sampleData; 
}




